import initialState from './initialState'
import * as types from '../actions/actionTypes'

const content = (state = initialState.content, action) => {
  switch (action.type) {
    case types.GET_CONTENT:
      return { ...state, htmlContent: action.content }
    default:
      return state
  }
}

export default content



// WEBPACK FOOTER //
// ./src/reducers/contentReducer.js